import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useAlgo } from '../hooks/useAlgo';
import Alert from './Alert';
import { useRaffles } from '../hooks/useRaffles';
import Spinner from './Spinner';
import config from '../config';
import RafflePreview from './RafflePreview';

function TheRafflesPage({ raffles }) {
  const [collectionFilter, setCollectionFilter] = useState();
  const sortedRaffles = [...raffles]
    .filter((raffle) => {
      if (!collectionFilter) return true;
      const raffleOwner = config.raffleOwners.find((owner) => owner.id === raffle.owner);

      // shitty kitties
      if (collectionFilter === 'Treats') {
        return !raffle.owner || raffleOwner?.tokenAbbr === collectionFilter;
      }
      return raffleOwner?.tokenAbbr === collectionFilter;
    })
    .sort((a, b) => {
      const aTime = new Date(a.endDate).getTime();
      const bTime = new Date(b.endDate).getTime();
      return aTime - bTime;
    })
    .sort((a, b) => {
      if (b.winner) return -1;
      if (a.winner) return 1;
      return 0;
    });

  return (
    <div className='mt-10'>
      <div className='mb-5 flex justify-end'>
        <select
          value={collectionFilter}
          onChange={(e) => setCollectionFilter(e.target.value)}
          placeholder='Bet Amount'
          className='w-full md:w-auto form-input bg-gray-900 border-0 rounded-md py-4 focus:ring-2 focus:ring-white pr-10 text-lg'
        >
          <option disabled selected value={'_none'}>
            Filter by token
          </option>
          {[...config.raffleOwners]
            .sort((a, b) => {
              if (a.tokenAbbr < b.tokenAbbr) return -1;
              if (a.tokenAbbr > b.tokenAbbr) return 1;
              return 0;
            })
            .map((owner) => (
              <option key={owner.tokenAbbr} value={owner.tokenAbbr}>
                {owner.tokenAbbr}
              </option>
            ))}
        </select>
      </div>
      <div className='mx-auto space-y-10 w-full'>
        {sortedRaffles?.length > 0 ? (
          <div
            className={`grid w-full grid-cols-1 gap-10 md:grid-cols-2 ${
              sortedRaffles.length === 1
                ? 'lg:grid-cols-1 max-w-md mx-auto'
                : sortedRaffles.length === 2
                ? 'lg:grid-cols-2 max-w-3xl mx-auto'
                : 'lg:grid-cols-3'
            }`}
          >
            {sortedRaffles.map((raffle, index) => (
              <motion.div key={raffle?.id}>
                <RafflePreview raffle={raffle} />
              </motion.div>
            ))}
          </div>
        ) : (
          <div className='max-w-md col-span-1 col-start-2 mx-auto space-y-10'>
            <Alert type='danger'>
              <span>No active raffles found</span>
            </Alert>
            <p className='text-[24px] text-center max-w-sm mx-auto'>
              <a href={config.discord} target='_blank' rel='noreferrer' className='font-bold text-primary-500'>
                Join Discord
              </a>{' '}
              for more information on the next one!
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default TheRafflesPage;
